module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":{"label":"Jumlah","placeholder":"0"},"coupon_error":{"default":"*Kode Kupon tidak valid","invoice_datetime":"*Kupon ini {condition}","subtotal_no_tax":"*Min order: {min_order}"}}}')
  delete Component.options._Ctor
}
